import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Homepage from './pages/jsx/Homepage';
import AboutUs from './pages/jsx/AboutUs';
import AllProducts from './pages/jsx/AllProducts';
import ProductCategories from './pages/jsx/ProductCategories';
import ProductDetails from './pages/jsx/ProductDetails';
import ContactUs from './pages/jsx/ContactUs';
import InternationalShipping from './pages/jsx/InternationalShipping';
import QualityAssurance from './pages/jsx/QualityAssurance';
import './styles/global.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<AllProducts />} />
          <Route path="/categories" element={<ProductCategories />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/shipping" element={<InternationalShipping />} />
          <Route path="/quality" element={<QualityAssurance />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
